export function arqueacaoAutoInRequest(params = {}) {
  return {
    type: '@arqueacaoautomatica/ARQUEACAOAUTO_IN_REQUEST',
    payload: { params },
  };
}

export function findArqueacaoAuto(idarqueacaoautomatica) {
  return {
    type: '@arqueacaoautomatica/FIND_ARQUEACAOAUTO',
    payload: { idarqueacaoautomatica },
  };
}

export function failedRequest() {
  return {
    type: '@arqueacaoautomatica/FAILED_REQUEST',
  };
}

export function deleteArqueacaoAuto(idarqueacaoautomatica, params) {
  return {
    type: '@arqueacaoautomatica/DELETE_ARQUEACAOAUTO',
    payload: { idarqueacaoautomatica, params },
  };
}

export function updateArqueacaoAuto(idarqueacaoautomatica, params) {
  return {
    type: '@arqueacaoautomatica/UPDATE_ARQUEACAOAUTO',
    payload: { idarqueacaoautomatica, params },
  };
}

export function storeArqueacaoAuto(idarqueacaoautomatica, params) {
  return {
    type: '@arqueacaoautomatica/STORE_ARQUEACAOAUTO',
    payload: { idarqueacaoautomatica, params },
  };
}

export function successInRequest(
  arqueacoes,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@arqueacaoautomatica/SUCCESS_IN_REQUEST',
    payload: { arqueacoes, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(arqueacao) {
  return {
    type: '@arqueacaoautomatica/SUCCESS_REQUEST',
    payload: { arqueacao },
  };
}

export function successRemove(params) {
  return {
    type: '@arqueacaoautomatica/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@arqueacaoautomatica/RECORD_FILTERING',
    payload: { params },
  };
}
